<template>
  <div class="home-slide-one">
    <div class="banner">
      <div class="banner-left">
        <p class="banner-blue">
          蓝凌智能OA<span>·</span>企业移动智能化办公首选
        </p>
        <p class="banner-plat f-weight">赋能中小企业实现数字化办公</p>
        <p class="banner-plat f-weight">让团队协同更高效流畅</p>
        <div>
          <img
            src="../assets/decorate/btn-shadow.png"
            alt
            class="shadow-cion animated fadeIn"
            v-if="showBoxShadow"
          />
          <p
            class="banner-use point"
            @mouseenter="showBoxShadow = true"
            @mouseleave="showBoxShadow= false"
            @click="showLogin()"
          >免费试用</p>
        </div>
      </div>
      <div class="banner-right">
        <img src="../assets/banner.png" alt />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      showBoxShadow: false
    }
  },
  methods: {
    showLogin() {
      _czc.push(["_trackEvent", "banner_按钮_立即体验", "button"]);
      this.$root.$emit('change',true)
    }
  }
}
</script>

<style lang="less">
.home-slide-one {
  width: 100%;
  height: 450px;
  background: url("../assets/banner-bg2.png") 0 -70px no-repeat;
  background-size: cover;
  background-color: #FFF;
  text-align: center;

  .banner {
    display: flex;
    width: 1200px;
    height: 450px;
    margin: 0 auto;
  }

  .banner-left {
    padding-left: 70px;
    padding-top: 100px;
    > div {
      position: relative;
    }
    span {
      margin-right: 2px;
      margin-left: 2px;
    }
    .banner-blue {
      color: #4285f4;
      font-size: 24px;
      font-weight: normal;
      text-align: left;
      margin-bottom: 25px;
      // span{
      //   font-size: 36px;
      // }
    }
    .banner-plat {
      font-size: 34px;
      color: #333333;
      line-height: 36px;
      text-align: left;
      line-height:52px;
    }
    .banner-use {
      width: 148px;
      height: 48px;
      margin-top: 30px;
      line-height: 48px;
      text-align: center;
      color: white;
      // background-image: linear-gradient(-45deg, #5A87FF 0%, #186fff 100%);
      // border-radius: 21px;
      background-image: linear-gradient(66deg, #5A87FF 0%, #89A6FF 100%);
      border-radius: 24px;
    }
  }
  .banner-right {
    width: 600px;
    margin-left:80px;
    img {
      width: 100%;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/home-slide-one.vue